/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeatureResource } from '../models/FeatureResource'
import type { FeatureStore } from '../models/FeatureStore'
import type { FeatureWrite } from '../models/FeatureWrite'
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
import type { HubFeatureFlagResource } from '../models/HubFeatureFlagResource'
import type { DisabledOrganizationResource } from '../models/DisabledOrganizationResource'

export class FeaturesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Main Feature List (not feature toggles).
     * Single-word fuzzy search enabled.
     * @returns any OK
     * @throws ApiError
     */
    public getFeatures({
        page,
        search
    }: {
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
        /**
         * Search term for fuzzy matching feature names
         */
        search?: string
    }): CancelablePromise<{
        data: Array<FeatureResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/features',
            query: {
                page: page,
                search: search
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Used for creating new features.
     * @returns void
     * @throws ApiError
     */
    public createFeature({ requestBody }: { requestBody: FeatureStore }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/features',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Get a single feature.
     * @returns any OK
     * @throws ApiError
     */
    public getFeature({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: FeatureResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/features/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete a feature.
     * @returns void
     * @throws ApiError
     */
    public deleteFeature({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/features/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update endpoint for features.
     * @returns any OK
     * @throws ApiError
     */
    public updateFeature({
        id,
        requestBody
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody: FeatureWrite & {
            /**
             * CleanupOrganizations old feature toggles that are not applicable to the current status
             */
            cleanup?: boolean
        }
    }): CancelablePromise<{
        data: FeatureResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/features/{id}',
            path: {
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
    /**
     * List known THub feature flag slugs, for merging into the organization feature flag filter.
     * Only includes flags that have been seen on at least one Breeze-linked organization - this is
     * not the full catalog of every flag defined in Hub, just the ones Breeze is aware of.
     * @returns any OK
     * @throws ApiError
     */
    public getHubFeatureFlags(): CancelablePromise<{
        data: Array<HubFeatureFlagResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/features-hub-flags',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
    /**
     * List the organizations that have disabled this feature at the org level, with their reasons.
     * Paginated.
     * @returns any OK
     * @throws ApiError
     */
    public getFeatureDisabledOrganizations({
        id,
        page
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
    }): CancelablePromise<{
        data: Array<DisabledOrganizationResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/features/{id}/organizations',
            path: {
                id: id
            },
            query: {
                page: page
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
